import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabasesDisplayGridRowDataFragmentGql } from './DatabasesDisplayGridRowFragmentGql';

export const TableDownstreamDatabasesQueryGql: DocumentNode = gql`
query TableDownstreamDatabasesQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!, $publishedConnectionsLineageEnabled: Boolean!) {
  tables(filter: { id: $tableId }) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${DatabasesDisplayGridRowDataFragmentGql}
`;
